import { hasFailed } from './state';
import { defaultInitConfig } from './const';
import { createKeycloak, initKeycloak } from './keycloak';
import { isFunction, isNil } from './utils';
export const vueKeycloak = {
    install: async (app, options) => {
        if (isNil(options)) {
            hasFailed(true, new Error('The VueKeycloakPluginConfig is required'));
            return;
        }
        let keycloakPluginConfig;
        if (isFunction(options)) {
            keycloakPluginConfig = await options();
        }
        else {
            keycloakPluginConfig = options;
        }
        if (isNil(keycloakPluginConfig.config)) {
            hasFailed(true, new Error('The KeycloakConfig is required'));
            return;
        }
        const keycloakConfig = keycloakPluginConfig.config;
        const keycloakInitOptions = !isNil(keycloakPluginConfig.initOptions)
            ? { ...defaultInitConfig, ...keycloakPluginConfig.initOptions }
            : defaultInitConfig;
        const _keycloak = createKeycloak(keycloakConfig);
        if (isNil(_keycloak))
            return;
        app.config.globalProperties.$keycloak = _keycloak;
        await initKeycloak(keycloakInitOptions);
    },
};
//# sourceMappingURL=plugin.js.map